import { svg } from 'lit';
export const circleSvg = svg `<svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="2" cy="2" r="2" fill="white" fill-opacity="0.2"/>
</svg>
`;
//# sourceMappingURL=circle.js.map